import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { eSiteType } from 'src/app/entity/enum/enum-site-type';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { ActivatedRoute } from '@angular/router';
import { MatSelectChange } from '@angular/material/select';
@Component({
  selector: 'app-cd001-card-classificacao-V',
  templateUrl: './cd001-card-classificacao-V.component.html',
})
export class Cd001CardClassificacaoVComponent extends GeneralComponent implements OnInit {

  /*
  changeSelect(liberacao_especial: any) {
    throw new Error('Method not implemented.');
  }
  */
  public formulario?: FormGroup;
  public listDiscoSocidisco?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listDiscoApollo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listAnelSocidisco?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listAnelApollo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLiberacaoEspecial?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listGrafite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listSite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listProcesso?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listDestino?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listDiscoApolloOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listAnelApolloOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();

  public listGrafiteOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listGeneration?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listDiscoSocidiscoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();

  public listAnelSocidiscoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();

  public listLiberacaoEspecialOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();

  public listSiteOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listProcessoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listOrigemOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listPeneiraOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listDestinoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  @Output() mkCalc = new EventEmitter();
  @Output() generationChoose = new EventEmitter();
  public ngSelectedGrafite = 'NÃO'
  area: string = eAreaType.commercial;
  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    super('Torre de classificação e Resultados Precision Planting', false);
    if (this.isComercial) {
      this.formulario = this.formBuilder.group({
        disco_socidisco: [null, []],
        anel_socidisco: [null, []],
        disco_apollo: [null, []],
        anel_apollo: [null, []],
        prc_falha_socidisco: [null, []],
        prc_dupla_socidisco: [null, []],
        prc_singulacao_socidisco: [null, []],
        prc_falha_apollo: [null, []],
        prc_dupla_apollo: [null, []],
        prc_singulacao_apollo: [null, []],
        resultado_precision_planting: [null, []],
        motivo_reprovacao_precision_planting: [null, []],
        liberacao_especial: [null, []],
        motivo_liberacao_especial: [{ value: null, disabled: true }, []],
        grafite: [null, []],
        criado_por: [null, []],

      });
    } else {
      this.formulario = this.formBuilder.group({
        disco_apollo: [null, [Validators.required]],
        anel_apollo: [null, [Validators.required]],
        prc_falha_apollo: [null, [Validators.required]],
        prc_dupla_apollo: [null, [Validators.required]],
        prc_singulacao_apollo: [null, [Validators.required]],
        resultado_precision_planting: [null, []],
        motivo_reprovacao_precision_planting: [null, []],
        grafite: [null, [Validators.required]],
      })

    }
  }

  public async ngOnInit(): Promise<void> {
    this.getArea();
    this.enableInputs();
    await this.getLists();
    await this.getListGeneration();
  }
  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }
  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }
  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }
  public async getLists(): Promise<void> {
    await Promise.all([
      this.getDiscoSocidisco(),
      this.getAnelSocidisco(),
      this.getDiscoApollo(),
      this.getAnelApollo(),
      this.getLiberacaoEspecial(),
      this.getGrafite(),
      this.getListSite(),
      this.getDropDownProcesso(),
      this.getListOrigem(),
      this.getDropdownPeneira(),
      this.getListDestino(),
    ]);
  }

  async getDiscoSocidisco(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'disco_socidisco')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listDiscoSocidisco = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listDiscoSocidiscoOriginal = this.listDiscoSocidisco;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }
  async getDiscoApollo(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'disco_apollo')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listDiscoApollo = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listDiscoApolloOriginal = this.listDiscoApollo;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }
  async getAnelSocidisco(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'anel_socidisco')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listAnelSocidisco = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listAnelSocidiscoOriginal = this.listAnelSocidisco;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }
  async getAnelApollo(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'anel_apollo')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listAnelApollo = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listAnelApolloOriginal = this.listAnelApollo;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }
  async getLiberacaoEspecial(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'liberacao_especial')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listLiberacaoEspecial = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listLiberacaoEspecialOriginal = this.listLiberacaoEspecial;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }
  async getGrafite(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', this.isBasica ? 'grafite_basica' : 'grafite')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listGrafite = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listGrafiteOriginal = this.listGrafite;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }

  async getListSite(): Promise<void> {
    this.listSite = this.generalService.getListSiteRecebimento();
    this.listSiteOriginal = this.listSite;
    // await this.formularioService.getListDropDownList('qua007', 'site_origem').pipe(take(1)).toPromise().then(response => {
    //     if (!!response?.data) {
    //         this.listSite = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
    //         this.listSiteOriginal = this.listSite;
    //     }
    // }).catch(async (error: HttpErrorResponse) => {
    //     this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
    // });
  }

  async getListProcesso(area?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'processo', area)
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listProcesso = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listProcessoOriginal = this.listProcesso;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorProcesso
        );
      });
  }

  async getListOrigem(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'origem')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listOrigem = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listOrigemOriginal = this.listOrigem;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorLoteOrigem
        );
      });
  }

  async getListPeneira(site?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'peneira', site)
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listPeneira = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraOriginal = this.listPeneira;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneira
        );
      });
  }

  async getListDestino(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'destino')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listDestino = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listDestinoOriginal = this.listDestino;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorDestino
        );
      });
  }

  async createFilterDiscoSocidisco(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listDiscoSocidiscoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listDiscoSocidisco = this.listDiscoSocidiscoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listDiscoSocidisco = this.listDiscoSocidiscoOriginal;
      }
    } else {
      this.listDiscoSocidisco = this.listDiscoSocidiscoOriginal;
    }
  }
  async createFilterDiscoApollo(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listDiscoApolloOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listDiscoApollo = this.listDiscoApolloOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listDiscoApollo = this.listDiscoApolloOriginal;
      }
    } else {
      this.listDiscoApollo = this.listDiscoApolloOriginal;
    }
  }
  async createFilterAnelApollo(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listAnelApolloOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listAnelApollo = this.listAnelApolloOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listAnelApollo = this.listAnelApolloOriginal;
      }
    } else {
      this.listAnelApollo = this.listAnelApolloOriginal;
    }
  }
  async createFilterAnelSocidisco(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listAnelSocidiscoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listAnelSocidisco = this.listAnelSocidiscoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listAnelSocidisco = this.listAnelSocidiscoOriginal;
      }
    } else {
      this.listAnelSocidisco = this.listAnelSocidiscoOriginal;
    }
  }

  async createFilterSite(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listSiteOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listSite = this.listSiteOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listSite = this.listSiteOriginal;
      }
    } else {
      this.listSite = this.listSiteOriginal;
    }
  }

  async createFilterProcesso(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listProcessoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listProcesso = this.listProcessoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listProcesso = this.listProcessoOriginal;
      }
    } else {
      this.listProcesso = this.listProcessoOriginal;
    }
  }

  async createFilterOrigem(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listOrigemOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listOrigem = this.listOrigemOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listOrigem = this.listOrigemOriginal;
      }
    } else {
      this.listOrigem = this.listOrigemOriginal;
    }
  }

  async createFilterPeneira(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listPeneiraOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listPeneira = this.listPeneiraOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listPeneira = this.listPeneiraOriginal;
      }
    } else {
      this.listPeneira = this.listPeneiraOriginal;
    }
  }

  async createFilterDestino(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listDestinoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listDestino = this.listDestinoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listDestino = this.listDestinoOriginal;
      }
    } else {
      this.listDestino = this.listDestinoOriginal;
    }
  }

  async getListGeneration(): Promise<void> {
    await this.formularioService
      .getListGeneration()
      .then((response) => {
        if (response.length > 0) {
          this.listGeneration =
            this.generalService.orderByDropDownList(response);
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorGeneration
        );
      });
  }

  getArea = () => {
    this.route.paramMap.subscribe((paramMap) => {
      this.area = paramMap.get('area');
    });
  };

  enableInputs = () => {
    switch (this.area) {
      case eAreaType.basic:
        // this.formulario.controls.basic.enable();
        // this.formulario.controls.generation.enable();
        // this.formulario.controls.porcentagem_falha.enable();
        // this.formulario.controls.vazao.enable();
        // this.formulario.controls.responsavel_especial.enable();
        break;
    }
  };

  getHibridoDropdown = async () => {
    if (this.area !== eAreaType.basic) {
      // await this.getListHibrido();
    } else {
      await this.getListHibridoCDR();
    }
  };

  async getListHibridoCDR(): Promise<void> {
    await this.formularioService
      .getListHibridoDropdown()
      .then((res) => {
        // this.listHibrido = res;
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }

  getDropdownPeneira = async () => {
    switch (this.area) {
      case eAreaType.basic:
        await this.getListPeneira(eSiteType.cdr.toLowerCase());
        break;
      default:
        await this.getListPeneira();
        break;
    }
  };

  getDropDownProcesso = async () => {
    switch (this.area) {
      case eAreaType.basic:
        await this.getListProcesso(eAreaType.basic.toLowerCase());
        break;

      default:
        await this.getListProcesso();
        break;
    }
  };

  generationChange = (event: MatSelectChange) => {
    this.generationChoose.emit(event.value);
  }

  checkPrc(event, formControl): void {


    let value = Number(event.value.replace(".", "").replace(",", "."))

    if (value < 0 || value > 30) {


      this.formulario.get(formControl).setErrors({ invalidApolloSocidisco: true });
      this.formulario.get(formControl).markAsTouched();


    }
  }

  changeSelect(event) {
    const value = event?.value ?? event


    if (value == "SIM") {
      this.formulario.get("motivo_liberacao_especial")?.enable()
      this.formulario.get("motivo_liberacao_especial")?.setValidators(Validators.required)
      this.formulario.get("motivo_liberacao_especial")?.updateValueAndValidity()


    }
    else {
      this.formulario.get("motivo_liberacao_especial")?.setValue(null)
      this.formulario.get("motivo_liberacao_especial")?.disable()
      this.formulario.get("motivo_liberacao_especial")?.clearValidators()
      this.formulario.get("motivo_liberacao_especial")?.updateValueAndValidity()
    }

  }


}
